import React from "react";

const ContactUs = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Empty space taking 25% of viewport height */}
      <div className="h-1/4 min-h-[25vh]"></div>
      
      {/* Contact content */}
      <div className="container mx-auto px-4 pb-16">
        <h1 className="text-3xl font-bold text-center text-red-600 mb-12">Contact Us</h1>
        
        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          {/* Email Us Section */}
          <div className="bg-white shadow-lg rounded-lg p-6 w-full md:w-1/3 text-center flex flex-col h-64">
            <div className="flex justify-center mb-4">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-12 w-12 text-red-600" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-red-600 mb-2">Email Us</h2>
            <p className="text-gray-700 mb-6">
              contact.fluentalk@gmail.com
            </p>
            <div className="mt-auto">
              <a 
                href="mailto:contact.fluentalk@gmail.com" 
                className="bg-red-600 hover:bg-red-700 text-white py-2 px-6 rounded-lg transition duration-300 inline-block"
              >
                Send Email
              </a>
            </div>
          </div>

          {/* Write to Us Section */}
          <div className="bg-white shadow-lg rounded-lg p-6 w-full md:w-1/3 text-center flex flex-col h-64">
            <div className="flex justify-center mb-4">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-12 w-12 text-red-600" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" 
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-red-600 mb-2">Write to Us</h2>
            <p className="text-gray-700 mb-6">
              Fill out our contact form
            </p>
            <div className="mt-auto">
              <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLSdSPVjT-xeAyg1KY--8toP_EfuKZVwhfMVTM4PJiGyfamvkqQ/viewform?usp=dialog" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-red-600 hover:bg-red-700 text-white py-2 px-6 rounded-lg transition duration-300 inline-block"
              >
                Open Form
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;